import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col, Label } from 'reactstrap';
import { AvFeedback, AvForm, AvGroup, AvInput, AvField } from 'availity-reactstrap-validation';
import { Translate, translate, ICrudGetAction, ICrudGetAllAction, ICrudPutAction } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IRootState } from 'app/shared/reducers';

import { getEntity, updateEntity, createEntity, reset } from './wechat-user.reducer';
import { IWechatUser } from 'app/shared/model/wechat-user.model';
import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';

export interface IWechatUserUpdateProps extends StateProps, DispatchProps, RouteComponentProps<{ id: string }> {}

export const WechatUserUpdate = (props: IWechatUserUpdateProps) => {
  const [isNew, setIsNew] = useState(!props.match.params || !props.match.params.id);

  const { wechatUserEntity, loading, updating } = props;

  const handleClose = () => {
    props.history.push('/wechat-user');
  };

  useEffect(() => {
    if (isNew) {
      props.reset();
    } else {
      props.getEntity(props.match.params.id);
    }
  }, []);

  useEffect(() => {
    if (props.updateSuccess) {
      handleClose();
    }
  }, [props.updateSuccess]);

  const saveEntity = (event, errors, values) => {
    if (errors.length === 0) {
      const entity = {
        ...wechatUserEntity,
        ...values,
      };

      if (isNew) {
        props.createEntity(entity);
      } else {
        props.updateEntity(entity);
      }
    }
  };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="examsysApp.wechatUser.home.createOrEditLabel">
            <Translate contentKey="examsysApp.wechatUser.home.createOrEditLabel">Create or edit a WechatUser</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <AvForm model={isNew ? {} : wechatUserEntity} onSubmit={saveEntity}>
              {!isNew ? (
                <AvGroup>
                  <Label for="wechat-user-id">
                    <Translate contentKey="global.field.id">ID</Translate>
                  </Label>
                  <AvInput id="wechat-user-id" type="text" className="form-control" name="id" required readOnly />
                </AvGroup>
              ) : null}
              <AvGroup>
                <Label id="nickNameLabel" for="wechat-user-nickName">
                  <Translate contentKey="examsysApp.wechatUser.nickName">Nick Name</Translate>
                </Label>
                <AvField id="wechat-user-nickName" type="text" name="nickName" />
              </AvGroup>
              <AvGroup>
                <Label id="avatarUrlLabel" for="wechat-user-avatarUrl">
                  <Translate contentKey="examsysApp.wechatUser.avatarUrl">Avatar Url</Translate>
                </Label>
                <AvField id="wechat-user-avatarUrl" type="text" name="avatarUrl" />
              </AvGroup>
              <AvGroup>
                <Label id="genderLabel" for="wechat-user-gender">
                  <Translate contentKey="examsysApp.wechatUser.gender">Gender</Translate>
                </Label>
                <AvField id="wechat-user-gender" type="text" name="gender" />
              </AvGroup>
              <AvGroup>
                <Label id="countryLabel" for="wechat-user-country">
                  <Translate contentKey="examsysApp.wechatUser.country">Country</Translate>
                </Label>
                <AvField id="wechat-user-country" type="text" name="country" />
              </AvGroup>
              <AvGroup>
                <Label id="provinceLabel" for="wechat-user-province">
                  <Translate contentKey="examsysApp.wechatUser.province">Province</Translate>
                </Label>
                <AvField id="wechat-user-province" type="text" name="province" />
              </AvGroup>
              <AvGroup>
                <Label id="cityLabel" for="wechat-user-city">
                  <Translate contentKey="examsysApp.wechatUser.city">City</Translate>
                </Label>
                <AvField id="wechat-user-city" type="text" name="city" />
              </AvGroup>
              <AvGroup>
                <Label id="languageLabel" for="wechat-user-language">
                  <Translate contentKey="examsysApp.wechatUser.language">Language</Translate>
                </Label>
                <AvField id="wechat-user-language" type="text" name="language" />
              </AvGroup>
              <AvGroup>
                <Label id="openidLabel" for="wechat-user-openid">
                  <Translate contentKey="examsysApp.wechatUser.openid">Openid</Translate>
                </Label>
                <AvField id="wechat-user-openid" type="text" name="openid" />
              </AvGroup>
              <AvGroup>
                <Label id="createDateLabel" for="wechat-user-createDate">
                  <Translate contentKey="examsysApp.wechatUser.createDate">Create Date</Translate>
                </Label>
                <AvField id="wechat-user-createDate" type="date" className="form-control" name="createDate" />
              </AvGroup>
              <AvGroup>
                <Label id="tokenLabel" for="wechat-user-token">
                  <Translate contentKey="examsysApp.wechatUser.token">Token</Translate>
                </Label>
                <AvField id="wechat-user-token" type="text" name="token" />
              </AvGroup>
              <AvGroup>
                <Label id="telLabel" for="wechat-user-tel">
                  <Translate contentKey="examsysApp.wechatUser.tel">Tel</Translate>
                </Label>
                <AvField id="wechat-user-tel" type="text" name="tel" />
              </AvGroup>
              <Button tag={Link} id="cancel-save" to="/wechat-user" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </AvForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

const mapStateToProps = (storeState: IRootState) => ({
  wechatUserEntity: storeState.wechatUser.entity,
  loading: storeState.wechatUser.loading,
  updating: storeState.wechatUser.updating,
  updateSuccess: storeState.wechatUser.updateSuccess,
});

const mapDispatchToProps = {
  getEntity,
  updateEntity,
  createEntity,
  reset,
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(WechatUserUpdate);
